import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from 'src/app/services/order.service';
import { MessageService } from 'primeng/api';
import { StorageService } from 'src/app/services/storage.service';
import { EstampService } from 'src/app/services/estamp.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BranchManagementService } from 'src/app/services/branch-management.service';
import { UserManagementService } from 'src/app/services/user-management.service';


interface City {
  name: string,
  code: string
}
@Component({
    selector: 'app-review-order-details',
    templateUrl: './review-order-details.component.html',
    styleUrls: ['./review-order-details.component.scss'],
    standalone: false
})
export class ReviewOrderDetailsComponent implements OnInit {
  @Input() reviewOrderData: any = [];
  @Input() paymentAmount: number;
  @Output() reviewOrderDataChange: EventEmitter<any> = new EventEmitter<[]>();
  @Output() addingReviewer: EventEmitter<any> = new EventEmitter<[]>();
  @Input() isPaymentActive: boolean;
  cities: City[];
  selectedCity!: City;
  orderId: number;
  order: any;
  reviewData: any;
  serviceType: any = '';
  orderDetails: any = [];
  stampDetails: any = [];
  signDetails: any = [];
  orderStatus: any = 'Waiting for Approval';
  currentDate = new Date;
  userName: string = '';
  selectedBranch: any;
  articles: any;
  reviewDetails: FormGroup;
  reviewEmail: FormArray;
  submitted: boolean = false;
  validEmail: any;
  branchDetails: any;
  userData: any;
  selectedReviewer: any;
  paymentDetails: any;
  constructor(private modalService: NgbModal,
    private estampService: EstampService,
    private messageService: MessageService,
    private storageService: StorageService,
    private orderService: OrderService,
    private userManagementService: UserManagementService,
    private formBuilder: FormBuilder, private branchManagementService: BranchManagementService) {
    this.reviewDetails = this.formBuilder.group({
      reviewEmail: this.formBuilder.array([]),
      reviewer: [null]
    });
    this.reviewDetails.reset();
  }

  ngOnInit(): void {
    this.getUserDetails();
    this.addNewDetails();
  }


  getArticles(id) {
    let queryParams = { state_code: id };
    this.estampService.getArticles(queryParams).subscribe((resp) => {
      this.articles = resp['content'];
      this.stampDetails.forEach(element => {
        this.articles.forEach(ele => {
          if (ele.id === element.article_id) {
            element.article_code = ele.article_code
          }
        })
      })

    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reviewOrderData.currentValue) {
      const data = changes.reviewOrderData.currentValue;
      if (data) {
        this.userName = this.storageService.getUser() || null;
        this.selectedBranch = this.storageService.getBranch() || null;
        this.reviewData = data;
        this.serviceType = data.serviceType;
        if(this.isPaymentActive){
          this.orderDetails = data.details.orderDetails.order_details[0];
        }
        else{
          this.orderDetails = data.details.order_details[0];
        }
        this.paymentDetails = data.details.payment;
        this.getBranchDetails(this.orderDetails.branch_id);
        if (this.orderDetails.estamps) {
          this.stampDetails = this.orderDetails.estamps;
          this.stampDetails = this.orderDetails.estamps.filter(estamp => 
          estamp.documentToBeEstamp === true || (estamp.first_party_name && estamp.first_party_name !== 'NA')
         );

          if (this.stampDetails.length > 0) {
            this.stampDetails.forEach(element => {
              if (element.stamp_duty_paid_by === 'first_party_name') {
                element.stamp_duty_paid_by_name = element.first_party_name;
             } else if (element.stamp_duty_paid_by === 'second_party_name') {
                element.stamp_duty_paid_by_name = element.second_party_name;
             }
            });
         }

          if (this.stampDetails.length != 0) {
            this.stampDetails.forEach(element => {
              element.stamp_duty_paid_by === 'first_party_name' ? element.stamp_duty_paid_by_name = element.first_party_name : '';
              element.stamp_duty_paid_by === 'second_party_name' ? element.stamp_duty_paid_by_name = element.second_party_name : '';
            })

          }
        }
        if (this.orderDetails.esigns) {
          this.signDetails = this.orderDetails.esigns.party_users;
        }




      }
    }

  }

  getBranchDetails(id) {
    this.branchManagementService.getBranchDetailById(id).subscribe(res => {
      this.branchDetails = res['content'][0];
    
      this.getArticles(this.branchDetails.state.state_code);
    })
  }
  removeDetails(index: number) {
  
    this.reviewEmailArray().removeAt(index);
    this.reviewDetails.value.reviewer.splice(index, 1);
    this.userData = [...this.userData];
  }

  reviewEmailArray(): FormArray {
    return this.reviewDetails.get('reviewEmail') as FormArray;
  }

  addNewDetails() {
    this.reviewEmailArray().push(this.initDetails());
  }

  initDetails() {
    return this.formBuilder.group({
      email: new FormControl(null, [Validators.email]),
    });
  }




  goBack() {
    const reviewOrder = { path: 'back', details: this.reviewData.details } 
      if(this.isPaymentActive){
      this.addingReviewer.emit({reviewer:this.reviewDetails.value.reviewer,isPlaceOrder:false})
    }
    else{
      this.reviewOrderDataChange.emit(reviewOrder);
    }
  }

  placeOrder() {
    this.submitted = true;
    const reviewEmail = [];
    this.reviewDetails.value.reviewEmail.forEach(element => {
      if (element.email) {
        reviewEmail.push(element.email);
      }
    })
    this.getEmailValid(reviewEmail)
  }



  getEmailValid(reviewEmail) {
    const data = { "order_reviewers": reviewEmail }
    this.orderService.verifyApproverEmail(data).subscribe(res => {
      this.validEmail = res['content'];
      if (this.validEmail.validated) {
        if (reviewEmail.length === 0) {
          this.messageService.add({ severity: 'warn', detail: 'Please add atleast one Checker to Proceed' });
        } else {
          if(this.isPaymentActive){
            this.reviewData.details.orderDetails.order_details[0].signatory_details = reviewEmail;
            const reviewOrder = { path: 'order', details: this.reviewData.details }
            //this.reviewOrderDataChange.emit(reviewOrder);
            this.addingReviewer.emit({reviewer:this.reviewDetails.value.reviewer,isPlaceOrder:true})
          }
          else{
            this.reviewData.details.order_details[0].order_reviewers = reviewEmail;
            const reviewOrder = { path: 'order', details: this.reviewData.details }
            this.reviewOrderDataChange.emit(reviewOrder);
          }  
        }
      } else {
        this.messageService.add({ severity: 'warn', detail: 'Please enter valid  Email for Checker (or) Checker does not have permissions' });
      }
    })
  }

  getUserDetails() {
    let account_id = this.storageService.getAccountId();
    this.orderService.getApproverEmail(account_id).subscribe(res => {
      if (res.content.length != 0) {
        this.userData = res['content'];
      }
    })
  }

  selectReviewer() {
    this.selectedReviewer = this.reviewDetails.value.reviewer;
    this.reviewEmailArray().clear();
    this.selectedReviewer.forEach((element, index) => {
      this.addNewDetails();
      this.reviewEmailArray().at(index).get('email').setValue(element.email);
    });
    if (this.selectedReviewer.length === 0) {
      this.addNewDetails();
    }
  }
}